class apiCommon {

    //Get запрос
    getRequest = async (url) => {
        const res = await fetch(url, {method: 'GET',})
        return res.json();
    }

    //Post запрос
    sendFormData = async (url, body) => {
        const res = await fetch(url, {
            method: 'POST',
            body: body
        })
        return res.json();
    }

    sendSomeData = async (clinicSort) => {
        return await this.sendFormData(`get-some-data`, clinicSort)
    }

    getSomeData = async (someParams) => {
        return await this.sendFormData(`get-some-data?someParams=${someParams}`)
    }
}
